import { Ad } from "@/extensions/obituary/types";

export interface AdFormData {
  id: Ad["id"];
  comment: string;
}

export function getAdsFromFormData(
  formData: FormData,
  ads: Ad[],
): AdFormData[] {
  const data = Object.fromEntries(formData.entries());

  const adData: AdFormData[] = [];
  for (const [key] of Object.entries(data)) {
    if (key.startsWith("ad-")) {
      const id = Number.parseInt(key.slice(3));
      const ad = ads.find((a) => a.id === id);

      const commentKey = `comment-${id}`;
      const commentValue = (data[commentKey] as string | undefined) ?? "";

      let comment: string;
      if (ad) {
        if (ad.version > 1) {
          comment = commentValue;
        } else {
          comment = "";
        }
      } else {
        /* Because sometimes ads don't load in time, even
          though we've added a comment to the change */
        comment = commentValue;
      }

      adData.push({ id, comment });
    }
  }

  return adData;
}

export default getAdsFromFormData;
